import { useMemo } from 'react';

import {
  EXTERNAL_APP_CONFIGS_BY_KEY,
  INTERNAL_APP_CONFIGS_BY_KEY,
} from '@hcs/app-configs';
import { useAccount } from '@hcs/authn';
import { CapabilityApplications } from '@hcs/types';

import { useCapabilitiesForUser } from './useCapabilitiesForUser';

export const useAppAccessCheckForUserMap = (userId: number | undefined) => {
  const query = useCapabilitiesForUser(userId);
  const data = useMemo(() => {
    return query.data?.reduce<Partial<Record<CapabilityApplications, boolean>>>(
      (accum, capability) => {
        const appConfig =
          EXTERNAL_APP_CONFIGS_BY_KEY[capability.application] ||
          INTERNAL_APP_CONFIGS_BY_KEY[capability.application];
        if (capability.category === 'product-access') {
          accum[capability.application] = true;
        } else if (appConfig && appConfig.type !== 'product') {
          accum[capability.application] = true;
        }
        return accum;
      },
      {},
    );
  }, [query.data]);
  return {
    ...query,
    data,
  };
};

export const useAppAccessCheckForUser = (
  userId: number | undefined,
  applicationKey: CapabilityApplications,
) => {
  const query = useAppAccessCheckForUserMap(userId);
  const data = query.data?.[applicationKey];
  return {
    ...query,
    data,
  };
};

export const useAppAccessCheck = (applicationKey: CapabilityApplications) => {
  const query = useAppAccessCheckMap();
  return {
    ...query,
    data: query.data?.[applicationKey],
  };
};

export const useAppAccessCheckMap = () => {
  const { data: account } = useAccount();
  const query = useAppAccessCheckForUserMap(account?.user.id);
  return query;
};
